import { render, staticRenderFns } from "./FormReversalCrypto.vue?vue&type=template&id=3bd5c5ec"
import script from "./FormReversalCrypto.vue?vue&type=script&lang=js"
export * from "./FormReversalCrypto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports